export default __webpack_public_path__ + "locales/tr/InfoPanel.json?hash=eaaa9b8cab8b60e4c433b2461b012be7";